/**
 * @generated SignedSource<<a154acd063ce1d93a258e8de467627d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreStuffActionEnum = "store_stuff_delete" | "store_stuff_update" | "%future added value";
export type StoreStuffTypeEnum = "premium_non_refundable" | "premium_refundable" | "%future added value";
export type StoreStuffId_storeStuffQuery$variables = {
  id: string;
};
export type StoreStuffId_storeStuffQuery$data = {
  readonly storeStuff: {
    readonly actions: ReadonlyArray<StoreStuffActionEnum>;
    readonly endAt: any | null;
    readonly id: string;
    readonly period: number | null;
    readonly stuff: {
      readonly id: string;
      readonly title: string;
    } | null;
    readonly title: string;
    readonly type: StoreStuffTypeEnum;
    readonly " $fragmentSpreads": FragmentRefs<"StoreStuffDescriptionList_storeStuff" | "StoreStuffUpdateDialog_storeStuff">;
  };
};
export type StoreStuffId_storeStuffQuery = {
  response: StoreStuffId_storeStuffQuery$data;
  variables: StoreStuffId_storeStuffQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actions",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Stuff",
  "kind": "LinkedField",
  "name": "stuff",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "period",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreStuffId_storeStuffQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StoreStuff",
        "kind": "LinkedField",
        "name": "storeStuff",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StoreStuffDescriptionList_storeStuff"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StoreStuffUpdateDialog_storeStuff"
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoreStuffId_storeStuffQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StoreStuff",
        "kind": "LinkedField",
        "name": "storeStuff",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "picture",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDeleted",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c7cca8eb41db9743e2ecced64d67c36",
    "id": null,
    "metadata": {},
    "name": "StoreStuffId_storeStuffQuery",
    "operationKind": "query",
    "text": "query StoreStuffId_storeStuffQuery(\n  $id: ID!\n) {\n  storeStuff(id: $id) {\n    id\n    title\n    actions\n    stuff {\n      id\n      title\n    }\n    ...StoreStuffDescriptionList_storeStuff\n    ...StoreStuffUpdateDialog_storeStuff\n    type\n    period\n    endAt\n  }\n}\n\nfragment StoreStuffDescriptionList_storeStuff on StoreStuff {\n  id\n  type\n  period\n  endAt\n  stuff {\n    id\n    title\n  }\n  created\n  createdBy {\n    ...UserAvatarText_user\n    id\n  }\n}\n\nfragment StoreStuffUpdateDialog_storeStuff on StoreStuff {\n  id\n  title\n  type\n  period\n  endAt\n  stuff {\n    id\n  }\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "2c0cecad48b48b62d1a18cae7cdf7445";

export default node;
